const platforms = [
  { display_name: "All", name: "all" },
  { display_name: "Machine", name: "vm" },
  { display_name: "Kubernetes", name: "kubernetes" },
];

export default platforms;
